<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-24 15:54:38
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-28 09:31:46
 * @FilePath: \sns-user-frontend\src\components\web\dialog.vue
 * @Description: 确认弹窗
-->

<template>
  <div class="dialog">
    <el-dialog 
      v-model="visible" 
      align-center
      :show-close="false"
      :lock-scroll="lockScroll"
      closeUpdate="closeUpdate"
      :modal="showModal"
      :class="props.customClass"
      :close-on-click-modal="closeOnClickModal"
      :zIndex="zIndex"
      @open="props.open"
      @close="onClickLayer"
    >
      <template #header>
        <p v-if="props.title" class="title">{{props.title}}</p>
      </template>
      <slot></slot>
      <template #footer v-if="showFoot">
        <slot name="footer">
          <div class="footer">
            <p @click="onClose">{{$t(props.cancelText)}}</p>
            <p @click="onConfirm">{{$t(props.confirmText)}}</p>
          </div>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';


const emit = defineEmits(['update:visible', 'onConfirm', 'onClose'])

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  // 标题
  title: {
    type: String
  },
  showFoot: {
    type: Boolean,
    default: true
  },
  // 确认文案
  confirmText: {
    type: String,
    default: 'ok'
  },
  // 取消文案
  cancelText: {
    type: String,
    default: 'cancel'
  },
  showModal: {
    type: Boolean,
    default: true
  },
  customClass: {
    type: String,
    default: ''
  },
  closeUpdate : {
    type: Boolean,
    default: true
  },
  lockScroll: {
    type: Boolean,
    default: true
  },
  // 点击背景是否可以关闭弹窗
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: Number,
  }
})

const visible = ref(false)

// 同步显示状态
watch(() => props.visible, (val) => {
  visible.value = val
}, {
  immediate: true,
  deep: true
})

// 弹窗关闭
const onClickLayer = () => {
  emit('update:visible', false)
  if (props.closeUpdate) {
    emit('onClose', 'closed')
  }
}

const onClose = () => {
  onClickLayer()
  emit('onClose', 'closed')
}


// 确认
const onConfirm = () => {
  emit('onConfirm', false)
}

</script>

<style lang="postcss" scoped>

.dialog {
  :deep(.el-dialog) {
    --el-dialog-width: fit-content;
    --el-dialog-padding-primary: 0;
    border-radius: 24px;
    background: #FAFAFA;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);
    .el-dialog__header {
      padding-bottom: 0;
      margin-right: 0;
    }
    .el-dialog__footer {
      padding-top: 0;
    }
  }
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 16px;
  padding: 24px 0 16px;
  font-family: 'orbit-M';
}
.footer {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  p {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 18px 0;
    line-height: 20px;
    color: var(--theme);
    cursor: pointer;
    &:first-child:after {
      position: absolute;
      right: 0;
      width: 100%;
      height: 100%;
      content: " ";
      border-right: 1px solid var(--line);
    }
  
  }
}
</style>